// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPage_page__-Ugtg","doc":"PrivacyPage_doc__6O3Dy","updated":"PrivacyPage_updated__z9IF2","note":"PrivacyPage_note__Xz+yW"};